import { forwardRef, type SVGProps } from 'react';
import { Star } from 'lucide-react';
export const SvgFavoriteStar = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ style, ...props }, ref) => <Star ref={ref as any} {...props} fill="currentColor" style={style || undefined} />,
);
